export const DEFAULT_MARKETPLACE_TITLE = "Untitled item";
